const SERVICE = 'chat-service'

const postChatDataApi = async (api, body, id) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process(`/chat/${id}/message`)

const getChatDataApi = async (api, id) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process(`/chat/${id}`)

module.exports = {
  postChatDataApi,
  getChatDataApi,
}
